import type { AppRoute } from '@/lib/routing/routing.types'
import { lazyWithRetry } from '@/lib/utils/lazy-with-retry'

const SuperAdminPage = lazyWithRetry(() => import('./pages/SuperAdminPage'))

const routes: AppRoute[] = [
  {
    path: 'super-admin',
    children: [
      {
        index: true,
        element: SuperAdminPage,
        meta: {
          title: 'superAdmin.index.title',
          require: { superAdminOnly: true },
        },
      },
    ],
  },
]

export default routes
